// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"893caa5f","453":"19a71fc5","732":"31192e44"}[chunkId] + ".chunk.js";
};